import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';

const PageWrapper = () => {
	const theme = useTheme();
	const isCompact = useMediaQuery(theme.breakpoints.down('md'));
	const sidebarWidth = isCompact ? 64 : 220;

	return (
		<Box sx={{ display: 'flex', minHeight: '100vh' }}>
			<CssBaseline />
			<Sidebar />
			<Box 
				component="main" 
				sx={{ 
					flexGrow: 1, 
					marginLeft: `${sidebarWidth}px`,
					width: `calc(100% - ${sidebarWidth}px)`,
					minHeight: '100vh',
					display: 'flex',
					flexDirection: 'column',
					transition: 'margin-left 0.3s ease, width 0.3s ease',
					overflow: 'hidden',
				}}
			>
				<Outlet />
			</Box>
		</Box>
	);
};

export default PageWrapper;